import { paths as timeManagementLogPaths } from '../TimeManagementLog/paths';
import { paths as timeCardPaths } from '../TimeCard/paths';

export const paths = [...timeManagementLogPaths, ...timeCardPaths];
